/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TemplateDelete$Params {
  'Active-Tenant-Identifier': string;
  templateType: 'opts-config' | 'tender-config' | 'order-charge-limits' | 'pos-status-notifications';
  templateId: string;
}

export function templateDelete(http: HttpClient, rootUrl: string, params: TemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, templateDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateType', params.templateType, {});
    rb.path('templateId', params.templateId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

templateDelete.PATH = '/ordering/templates/{templateType}/{templateId}';
